import { createGlobalState } from 'react-hooks-global-state';
import { IConfirmationApiResponse, IInsuranceProduct, IMembershipProduct, IStoredPayment } from './types';
import { PaymentType } from '@ace-clublabs/payment-types';
import { BrokerRegion } from '@lib/types';

type State = {
  selectedStoredMethod: IStoredPayment;
  selectedProduct: IInsuranceProduct | IMembershipProduct;
  selectedNewMethod: PaymentType;
  clubCode: string;
  newEnroll: string;
  emailFromWeb: string;
  transactionCheckMade: boolean;
  paymentUpdated: boolean;
  confirmationDetails: IConfirmationApiResponse;
  emailOnFile: boolean;
  sessionId: string;
  confirmationVisited: boolean;
  billPlan: string;
  memcid: string;
  brokerRegion: BrokerRegion;
  discount: number;
  renderCancel: boolean;
  referrer: string;
  isInitialRender: boolean;
  cancelMembershipAutoPayFailed: boolean;
};

const initialState: State = {
  selectedProduct: undefined as any,
  selectedStoredMethod: undefined as any,
  selectedNewMethod: undefined as any,
  clubCode: '004',
  newEnroll: '',
  emailFromWeb: '',
  paymentUpdated: false,
  transactionCheckMade: false,
  confirmationDetails: {} as any,
  emailOnFile: false,
  sessionId: '',
  confirmationVisited: false,
  billPlan: '',
  memcid: '',
  brokerRegion: undefined as any,
  discount: 0,
  renderCancel: false,
  referrer: '',
  isInitialRender: true,
  cancelMembershipAutoPayFailed: false,
};

export const createInitialState = (): State => {
  const sessionStateString = sessionStorage.getItem('manageAutopayState') || '{}';
  const sessionState = JSON.parse(sessionStateString);
  const state = { ...initialState, ...sessionState };
  return state;
};

export const createEmptyInitialState = (): State => {
  const state = { ...initialState };
  return state;
};

export const { useGlobalState } = createGlobalState<State>(createInitialState());
